export default {"src":"/fly/_next/static/media/Plus.47e2d6d6.svg","height":567,"width":567,"blurWidth":0,"blurHeight":0};